import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMutableRef } from '@carnica/utils/hooks';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { IMask } from 'react-imask';
import { analyzeStringRangeValue, formatRangeDate } from "./utils";
export var useRangeInput = function useRangeInput(params) {
  var valueProp = params.value,
    onChangeProp = params.onChange,
    disableDates = params.disableDates,
    maxDate = params.maxDate,
    minDate = params.minDate;
  var _useState = useState(valueProp ? formatRangeDate(valueProp) : ''),
    _useState2 = _slicedToArray(_useState, 2),
    stringValue = _useState2[0],
    setStringValue = _useState2[1];
  var onChangeRef = useMutableRef(onChangeProp);
  var valueRef = useMutableRef(valueProp);
  var onChange = useCallback(function (stringRange, e) {
    var value = valueRef.current;
    setStringValue(stringRange || '');
    var checkedValue = analyzeStringRangeValue({
      stringValue: stringValue,
      value: value,
      maxDate: maxDate,
      minDate: minDate,
      disableDates: disableDates
    });
    if (checkedValue) {
      var _onChangeRef$current;
      (_onChangeRef$current = onChangeRef.current) === null || _onChangeRef$current === void 0 ? void 0 : _onChangeRef$current.call(onChangeRef, checkedValue, e);
    }
  }, [minDate === null || minDate === void 0 ? void 0 : minDate.getTime(), maxDate === null || maxDate === void 0 ? void 0 : maxDate.getTime(), disableDates]);
  var maskOptions = useMemo(function () {
    return {
      mask: 'dd.MM.yyyy - dd.MM.yyyy',
      blocks: {
        yyyy: {
          mask: IMask.MaskedRange,
          from: 1,
          to: 9999
        },
        MM: {
          mask: IMask.MaskedRange,
          from: 1,
          to: 12
        },
        dd: {
          mask: IMask.MaskedRange,
          from: 1,
          to: 31
        }
      }
    };
  }, []);
  useEffect(function () {
    setStringValue(formatRangeDate(valueProp || []));
  }, [valueProp]);
  return {
    onChange: onChange,
    stringValue: stringValue,
    maskOptions: maskOptions
  };
};